import { CardWrapper } from "Components/Common/Card/index";
import { Hr } from "Components/Common/Hr/index";
import { LabelT6 } from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import SelectT2 from "Components/Common/Select/SelectT2";
import { Spacer } from "Components/Common/Spacer/index";
import {
  TypographyT56,
  TypographyT57,
} from "Components/Common/Typography/index";
import { FlexWrapperT7 } from "Components/Common/Wrapper/FlexWrapper";
import { Wrapper } from "Components/Common/Wrapper/index";
import Input from "Components/Input/index";
import React, { Fragment } from "react";
import ServiceTypeDetails from "./ServiceTypeDetails";
import ServiceModeDetails from "./ServiceModeDetails";
import { isDesmet, isDesmetSupplier } from "Utils/index";
import PlacesAutoComplete from "Components/PlacesAutoComplete/index";




const options = [
  { value: "supplier 01", label: "supplier 01" },
  { value: "supplier 02", label: "supplier 02" },
  { value: "supplier 03", label: "supplier 03" },
  { value: "supplier 04", label: "supplier 04" },
  { value: "supplier 05", label: "supplier 05" },
];

const CardT1 = (props) => {
  const {
    consignorPickupLocationList,
    handleOnChangeForPickupLocation,
    consignor_details,
    addressValue,
    handleOnChangeAddress,
    project_details,
    handleOnChangeForProjectDetails,
    serviceTypesList,
    handleOnClickServiceType,
    serviceTypeValue,
    serviceModeTypesList,
    service_mode,
    handleToggleServiceMode,
    isComponentDidMount,
    fromRef,
    addressRef
  } = props;
  return (
    <Fragment>
      <CardWrapper>
        <TypographyT56>Create Request</TypographyT56>
        <Hr />
        <Spacer spacing={"10px"} />
        <TypographyT57>Pickup Location</TypographyT57>
        <Spacer spacing={"8px"} />
        <Wrapper style={{ width: "fit-content" }} ref={fromRef} tabIndex={0}>
          <LabelT6>
            From
            <span style={{ color: 'red' }}> *</span>
          </LabelT6>
          <Spacer spacing={"3px"} />
          {/* <SelectT1
            placeholder={"Select"}
            isClearable={true}
            options={consignorPickupLocationList}
            isSearchable={true}
            value={consignor_details}
            onChange={handleOnChangeForPickupLocation}
          /> */}
         {!!isComponentDidMount && <Fragment>
            <PlacesAutoComplete
              // hasError={submitted && !stop.location && !consigners[index]}
               setLocation={handleOnChangeForPickupLocation}
                value={consignor_details.location || ''}
            />          
          </Fragment>}
        </Wrapper>
        <Spacer spacing={"8px"} />
        <Wrapper ref={addressRef} tabIndex={0}>
          <LabelT6>
            Address
          <span style={{color:'red'}}> *</span>
          </LabelT6>
          <Spacer spacing={"3px"} />
          <Input
            placeholder={"Enter here"}
            name={"source_address"}
            value={addressValue}
            onChange={handleOnChangeAddress}
          />
        </Wrapper>
        <Spacer spacing={"10px"} />
        <ProjectDetails
          project_details={project_details}
          handleOnChangeForProjectDetails={handleOnChangeForProjectDetails}
        />
        <TypographyT57>Consignment Type</TypographyT57>
        <Spacer spacing={"8px"} />
        <ServiceTypeDetails
          serviceTypesList={serviceTypesList}
          handleOnClickServiceType={handleOnClickServiceType}
          serviceTypeValue={serviceTypeValue}
        />
        <Spacer spacing={"8px"} />
        <ServiceModeDetails
          serviceModeTypesList={serviceModeTypesList}
          service_mode={service_mode}
          handleToggleServiceMode={handleToggleServiceMode}
        />
      </CardWrapper>
    </Fragment>
  );
};

export default CardT1;

export const ProjectDetails = (props) => {
  const {
    project_details = {},
    handleOnChangeForProjectDetails = () => {},
  } = props;
  return (
    <Fragment>
      <Fragment>
        <TypographyT57>Project Details</TypographyT57>
        <Spacer spacing={"8px"} />
        <FlexWrapperT7>
          <Wrapper className={"flex-1 "}>
            <LabelT6>Project Name</LabelT6>
            <Spacer spacing={"3px"} />
            <Input
              placeholder={"Enter here"}
              name={"project_name"}
              value={project_details.project_name}
              onChange={handleOnChangeForProjectDetails}
              disabled={!isDesmetSupplier()}
            />
          </Wrapper>
          <Wrapper className={"flex-1 "}>
            <LabelT6>Project ID</LabelT6>
            <Spacer spacing={"3px"} />
            <Input
              placeholder={"Enter here"}
              name={"project_id"}
              value={project_details.project_id}
              onChange={handleOnChangeForProjectDetails}
              disabled={!isDesmetSupplier()}
            />
          </Wrapper>
        </FlexWrapperT7>
        <Spacer spacing={"8px"} />
        <FlexWrapperT7>
          {/* <Wrapper className={"flex-1 "}>
              <LabelT6>PO Name</LabelT6>
              <Spacer spacing={"3px"} />
              <Input
                placeholder={"Enter here"}
                name={"po_name"}
                value={project_details.po_name}
                onChange={handleOnChangeForProjectDetails}
                disabled = {!isDesmetSupplier()}
              />
            </Wrapper> */}
          <Wrapper className={"flex-1 "}>
            <LabelT6>PO Number</LabelT6>
            <Spacer spacing={"3px"} />
            <Input
              placeholder={"Enter here"}
              name={"po_number"}
              value={project_details.po_number}
              onChange={handleOnChangeForProjectDetails}
              disabled={!isDesmetSupplier()}
            />
          </Wrapper>
        </FlexWrapperT7>
        <Spacer spacing={"10px"} />
      </Fragment>
    </Fragment>
  );
};
